import { HttpMethods } from "@/react/http";
import { emailBaseApi } from "@/react/services/api";

import { messagesEndpoint } from "./urls";
import { buildGetQuery } from "./query";

const MESSAGE_COUNT_LIMIT = 1000;

export const emailStatusApi = emailBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getEmails: build.query({
      query: (payload) => {
        return {
          url: messagesEndpoint(MESSAGE_COUNT_LIMIT, buildGetQuery(payload)),
          method: HttpMethods.GET,
        };
      },
    }),
  }),
});

export const { useLazyGetEmailsQuery } = emailStatusApi;
